export default [
  {
    name: "THERMS",
    links: {
      live: "https://www.therms.io/"
    },
    description:
      "<p>Me sumé al equipo como desarrollador frontend para ayudar a construir y refinar el sitio público.</p> <p>Hecho con Astro y potenciado por un backend en Ghost.js, el sitio entrega páginas estáticas rápidas aprovechando el flujo editorial de Ghost para la gestión de contenido.</p>",
    tags: ["TypeScript", "Astro", "Ghost.js"],
    images: [
      {
        thumb: require("@/assets/images/projects/THERMS/01-thumb.png"),
        full: require("@/assets/images/projects/THERMS/01.png"),
        alt: "THERMS logo."
      },
      {
        thumb: require("@/assets/images/projects/THERMS/02-thumb.png"),
        full: require("@/assets/images/projects/THERMS/02.png"),
        alt: "THERMS Home Screen."
      },
      {
        thumb: require("@/assets/images/projects/THERMS/03-thumb.png"),
        full: require("@/assets/images/projects/THERMS/03.png"),
        alt: "THERMS Features Page."
      },
      {
        thumb: require("@/assets/images/projects/THERMS/04-thumb.png"),
        full: require("@/assets/images/projects/THERMS/04.png"),
        alt: "THERMS Blog."
      }
    ]
  },
  {
    name: "Pupe Lepú",
    links: {
      repo: "https://github.com/totocorvidoni/vue-crafts-store",
      live: "https://tomascorridoni.com/pupe-lepu/"
    },
    description:
      "<p>Un catálogo online para productos artesanales.</p> <p>El sitio fue diseñado para mostrar en detalle los productos del cliente y dejar entrever su personalidad para crear una experiencia única.</p> <p>Posee el panel administrativo de Wordpress utiliza WooCommerce para la gestión de productos, lo que el cliente cargue aquí es reflejado en el sitio web al instante utilizando la REST API de WooCommerce.</p>",
    tags: ["Tienda", "Vue", "Wordpress", "WooCommerce", "API"],
    images: [
      {
        thumb: require("@/assets/images/projects/lepu/01-thumb.jpg"),
        full: require("@/assets/images/projects/lepu/01.jpg"),
        alt: "Pupe Lepú logo, un conejo dentro de un círculo gris."
      },
      {
        thumb: require("@/assets/images/projects/lepu/02-thumb.jpg"),
        full: require("@/assets/images/projects/lepu/02.jpg"),
        alt: "Varios productos en la tienda."
      },
      {
        thumb: require("@/assets/images/projects/lepu/03-thumb.jpg"),
        full: require("@/assets/images/projects/lepu/03.jpg"),
        alt:
          "La imagen de un zorro amigurumi apoyado sobre un libro y su descripción a la derecha."
      },
      {
        thumb: require("@/assets/images/projects/lepu/04-thumb.jpg"),
        full: require("@/assets/images/projects/lepu/04.jpg"),
        alt: "El panel administrativo mostrando los detalles de los productos."
      }
    ]
  },
  {
    name: "Bounty Tea",
    links: {
      live: "https://bountytea.com.ar"
    },
    description:
      "<p>Sitio web de blends de té artesanales.</p> <p>Está enfocado a que los visitantes puedan examinar los productos de forma detenida y dirigirlos a sus medios de contactos para realizar pedidos.</p> <p>Durante el primer año que se inaguró la web, sus ventas incrementaron considerablemente y actualmente más del 40% de los pedidos llegan por ese canal.</p>",
    tags: ["Productos", "HTML", "CSS"],
    images: [
      {
        thumb: require("@/assets/images/projects/bounty/01-thumb.jpg"),
        full: require("@/assets/images/projects/bounty/01.png"),
        alt: "Logo de Bounty Tea y links del sitio."
      },
      {
        thumb: require("@/assets/images/projects/bounty/02-thumb.jpg"),
        full: require("@/assets/images/projects/bounty/02.png"),
        alt: "Vista del producto Luna Roja con tira de otros blend arriba."
      },
      {
        thumb: require("@/assets/images/projects/bounty/03-thumb.jpg"),
        full: require("@/assets/images/projects/bounty/03.png"),
        alt: "Las diferentes presentaciones Individual, Tea Set, Degustación"
      },
      {
        thumb: require("@/assets/images/projects/bounty/04-thumb.jpg"),
        full: require("@/assets/images/projects/bounty/04.png"),
        alt: "Galería de los diferentes blends."
      }
    ]
  },
  {
    name: "Thou Shall Do",
    links: {
      repo: "https://github.com/totocorvidoni/todo-vue",
      live: "https://totocorvidoni.github.io/todo-vue/"
    },
    description:
      "<p>Hecho en Vue, mi app de listas.</p><p>Un gran ejercicio que me dio la oportunidad de concentrarme en la transferencia de datos y aspectos técnicos de un sitio web necesarios para cualquier tipo de funcionalidad compleja.</p><p> Aprovechando la simpleza de este tipo de aplicaciones me concentré en agregar funcionalidades adicionales como prioridades y fechas de vencimiento.</p>",
    tags: ["Lista", "Vue", "Vuex", "Sass"],
    images: [
      {
        thumb: require("@/assets/images/projects/todo/01-thumb.png"),
        full: require("@/assets/images/projects/todo/01.png"),
        alt: "Thou Shall Do logo."
      },
      {
        thumb: require("@/assets/images/projects/todo/02-thumb.png"),
        full: require("@/assets/images/projects/todo/02.png"),
        alt: "Quick mode todos."
      },
      {
        thumb: require("@/assets/images/projects/todo/03-thumb.png"),
        full: require("@/assets/images/projects/todo/03.png"),
        alt: "A full view with no project opened."
      },
      {
        thumb: require("@/assets/images/projects/todo/04-thumb.png"),
        full: require("@/assets/images/projects/todo/04.png"),
        alt: "A full view with a project and a todo selected."
      }
    ]
  },
  {
    name: "Mi biblioteca",
    links: {
      repo: "https://github.com/totocorvidoni/myLibrary",
      live: "https://totocorvidoni.github.io/myLibrary/"
    },
    description:
      "<p>Una biblioteca virtual que permite llevar cuenta de los libros que leiste.</p> <p>Lo mas importante de este proyecto fue como mostrar toda la información de cada libro en un formato encapsulado. Queria que cada elemento se sintiera natural dentro de ellos y eso me forzó a encontrar soluciones creativas para su implementación.</p>",
    tags: ["Libros", "Vue"],
    images: [
      {
        thumb: require("@/assets/images/projects/library/01-thumb.png"),
        full: require("@/assets/images/projects/library/01.png"),
        alt: "Thou Shall Do logo."
      },
      {
        thumb: require("@/assets/images/projects/library/02-thumb.png"),
        full: require("@/assets/images/projects/library/02.png"),
        alt: "Quick mode todos."
      },
      {
        thumb: require("@/assets/images/projects/library/03-thumb.png"),
        full: require("@/assets/images/projects/library/03.png"),
        alt: "A full view with no project opened."
      },
      {
        thumb: require("@/assets/images/projects/library/04-thumb.png"),
        full: require("@/assets/images/projects/library/04.png"),
        alt: "A full view with a project and a library selected."
      }
    ]
  },
  {
    name: "Encontrá a Wally",
    links: {
      repo: "https://github.com/totocorvidoni/find-wally",
      live: "https://totocorvidoni.github.io/find-wally/"
    },
    description:
      "<p>Jugá '¿Donde está Wally?' en linea! </p><p> Una aplicación hecha en Vue the permite navegar por la escena buscando los personajes escondidos, desde el servidor una aplicación de Rails se en carga de validar los intentos y mantener las puntuaciones.</p><p> Lo mejor fue deducir como validar los intentos de los jugadores, lo peor fue encontrar a Woof.</p>",
    tags: ["Juego", "Vue", "Rails", "API"],
    images: [
      {
        thumb: require("@/assets/images/projects/wally/01-thumb.jpg"),
        full: require("@/assets/images/projects/wally/01.jpg"),
        alt:
          "General view of the site, the scene on the left and the character status on the right."
      },
      {
        thumb: require("@/assets/images/projects/wally/02.jpg"),
        full: require("@/assets/images/projects/wally/02.jpg"),
        alt: "Faces of the hidden characters and the score board with names."
      },
      {
        thumb: require("@/assets/images/projects/wally/03.jpg"),
        full: require("@/assets/images/projects/wally/03.jpg"),
        alt:
          "A wheel with characters faces circling around a semi-transparent square"
      },
      {
        thumb: require("@/assets/images/projects/wally/04-thumb.jpg"),
        full: require("@/assets/images/projects/wally/04.jpg"),
        alt:
          "A congratulations message telling how long it took to beat the game and asking for the user to put on it's name to save the score."
      }
    ]
  }
];
